import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useMultiStepForm } from "@/hooks";
import { addToDataGrid } from "@/utils/data";
import { Step3 } from "@/components/FormSteps";
import { DataGrid, type DataGridItem } from "./DataGrid";
import SummaryStep from "./SummaryStep";

export const SummaryStep3: FC = () => {
  const { form } = useMultiStepForm();
  const { t } = useTranslation();
  const step3 = form.getValues().step3;

  const data: DataGridItem[] = [
    {
      id: "billing-method",
      label: t("summary.billingMethod"),
      value: t(`step3.q1_${step3.billingType}`),
    },
    ...addToDataGrid(
      "margin",
      t("step3.q1_margin"),
      `${t("zlValue", { value: step3.margin ?? "-" })}/${t("MWh")}`,
      step3.billingType === "dynamic" && Boolean(step3.margin),
    ),

    ...addToDataGrid(
      "fixed-fee",
      t("step3.q1_fixedFee"),
      t("zlValue", { value: step3.fixedFee ?? "-" }),
      step3.billingType === "dynamic" && Boolean(step3.fixedFee),
    ),
    ...addToDataGrid(
      "price",
      t("summary.price"),
      t("zlValue", { value: step3.fixedPrice ?? "-" }),
      step3.billingType === "constant",
    ),
    ...addToDataGrid(
      "tariff",
      t("step3.q1_tariffLabel"),
      step3.tariff?.name ?? "-",
      step3.billingType === "constant",
    ),
  ];

  return (
    <SummaryStep
      stepTitle="step3"
      stepKey="step3"
      cardTitle={`3. ${t("stepper.step3")}`}
      cardContent={<DataGrid items={data} dataTest="summary-step3-data-grid" />}
      formComponent={Step3}
    />
  );
};
